export const stack=[
    {
        area:'Linguagens',
        itens:[
            'Javascript',
            'Python',
            'Java',
            'Typescript'
        ]
    },
    {
        area:'Front-end',
        itens:[
            'React',
            'React Native',
        ]
    },
    {
        area:'Back-end',
        itens:[
            'Node',
            'Express',
            'FastAPI'
        ]
    },
    {
        area:'Banco de Dados',
        itens:[
            'PostgreSQL',
            'MySQL',
            'MongoDb',
        ]
    },
    {
        area:'Deploy',
        itens:[
            'Github',
            'Vercel',
            'Docker',
            'AWS',
        ]
    },

]